import {Link} from 'react-router-dom';
import './LegalText.scss';

const TermsOfUseText = () => {
    return (<div className="legal-text">
            <div className="legal-text-header">
                <h4>
                    Nutzungsbedingungen für das RePort-Portal
                </h4>
            </div>
            <span className="header-span">
                1. RePort-Portal
            </span> <br/>
            <span className="sub-header-span">
                1.1 Beschreibung des RePort-Portals
            </span>
            <p>
                Das RePort-Portal auf der Internetseite report.sportcast.de sowie deren Unterdomänen (insgesamt: <b>„Portal“</b>) wird von der
                Sportcast GmbH
                (<b>„Sportcast“</b>) betrieben und dient zur Planung, Steuerung, Überwachung und Optimierung der wertschöpferischen Tätigkeiten der
                Sportcast in allen Funktionsbereichen und auf allen Ebenen. Der ganzheitliche Ansatz zielt auf die vollständige Dokumentation aller
                relevanter fachbereichsspezifischer Informationen entlang der Wertschöpfungskette ab. Dabei soll es sich nicht nur um die Erfassung
                spieltagbezogener Informationen handeln, sondern auch um die Dokumentation weiterer begleitender wertschöpferischer Tätigkeiten auf
                Projekt- und Tagesgeschäftsebene. Insbesondere die Auskunft von externen Gewerken und Personal, welche Aktivitäten der
                Wertschöpfungskette von Sportcast beauftragte Dienstleister ausführen, ist für eine vollständige und ausführliche Dokumentation
                notwendig. Die zentrale Datensammlung sowie -verwaltung ermöglicht ein nachhaltiges Qualitätsmanagement. Da Vorfälle und
                Informationen sowie ergriffene Maßnahmen langfristig abrufbar gespeichert werden. Weiterhin ermöglicht es, Eingaben zu vergleichen
                und Auswirkungen (bspw. von geschehenen Fehlern) über die gesamte Wertschöpfungskette nachzuvollziehen.
            </p>
            <span className="sub-header-span">
                1.2 Nutzungsbedingungen für das Portal
            </span>
            <p>
                Durch diese Nutzungsbedingungen für das Portal (<b>„Nutzungsbedingungen“</b>) werden der Zugang zu dem Portal und dessen Nutzung durch
                Nutzerinnen und Nutzer (nachfolgend einheitlich bezeichnet als: <b>„Nutzer“</b>), die aufgrund ihrer Tätigkeit durch die Sportcast
                durch
                Zuteilung eines Benutzernamens und Passworts zur Nutzung des Portals legitimiert sind, verbindlich geregelt. Diese
                Nutzungsbedingungen gelten dabei ergänzend zu den/der <Link to="/legal-hints" target="_blank" rel="noreferrer">Rechtlichen
                Hinweisen</Link> (<b>„Rechtliche
                Hinweise“</b>) und <Link to="/data-privacy" target="_blank" rel="noreferrer">Datenschutzerklärung
                und
                Cookie-Richtlinie</Link> (<b>„Datenschutzerklärung“</b>). Im Fall von
                Widersprüchen gilt folgender Anwendungsvorrang:
            </p>
            <p>
                1. Nutzungsbedingungen <br/>
                2. Datenschutzerklärung <br/>
                3. Rechtliche Hinweise <br/>
            </p>
            <p>
                Der Nutzer erklärt, dass er die vorgenannten Bedingungen verstanden hat und mit ihnen einverstanden ist. Erkennt der Nutzer diese
                nicht an, ist ihm die Nutzung des Portals untersagt.
            </p>
            <span className="header-span">
                2. Begründung des Nutzungsverhältnisses, Unentgeltlichkeit, Passwort und Zugangskennung
            </span><br/>
            <span className="sub-header-span">
                2.1 Begründung des Nutzungsverhältnisses
            </span>
            <p>
                Das Nutzungsverhältnis zwischen dem Nutzer und der Sportcast kommt zustande durch
            </p>
            <ul>
                <li>
                    ordnungsgemäßen Durchlauf des Registrierungsverfahrens,
                </li>
                <li>
                    Authentifizierung mit dem von der Sportcast zugeteilten Benutzernamen und Passwort, und
                </li>
                <li>
                    Akzeptanz dieser Nutzungsbedingungen, der Datenschutzerklärung und der Rechtlichen Hinweise.
                </li>
            </ul>
            <p>
                Der Nutzer sichert zu, dass sämtliche Angaben gegenüber der Sportcast im Rahmen der Registrierung vollständig und wahrheitsgemäß sind.
                Er verpflichtet sich, Änderungen unverzüglich schriftlich oder in Textform mitzuteilen bzw., soweit vorgesehen, in sein entsprechendes
                Nutzerprofil im Portal einzugeben.
            </p>
            <span className="sub-header-span">
                2.2 Unentgeldlichkeit
            </span>
            <p>
                Die Nutzung des Portals durch den Nutzer erfolgt unentgeltlich, soweit nicht für bestimmte Inhalte unter Abschluss eines gesonderten
                Vertrags ein Entgelt vereinbart wird.
            </p>
            <span className="sub-header-span">
                2.3 Verwendung von Benutzername und Passwort
            </span>
            <p>
                Benutzername und Passwort sind für den Nutzer persönlich bestimmt und von diesem vertraulich zu behandeln, vor dem Zugriff unbefugter
                Dritter zu schützen und, soweit sich aus diesen Nutzungsbedingungen nichts anderes ergibt, nicht an Dritte weiterzugeben. Der Nutzer
                erkennt an, dass er als Inhaber eines Zugangs für alle Aktivitäten, die darüber durch ihn oder Dritte ausgeübt werden, verantwortlich
                ist. Der Nutzer ist insbesondere für Inhalte verantwortlich, die in seinem Namen in das Portal eingestellt werden. Sollte der Nutzer
                Kenntnis darüber erlangen, dass eine unbefugte Nutzung seiner Zugangsberechtigung oder ein sonstiger Verstoß gegen diese
                Nutzungsbedingungen vorliegt, hat er die Sportcast über die E-Mail-Adresse <a
                href="mailto:registration.report@sportcast.de">registration.report@sportcast.de</a> unververzüglich zu
                unterrichten.
            </p>
            <p>
                Vorbehaltlich anderweitiger Mitteilung der Sportcast ist der Nutzer verpflichtet, das von der Sportcast übermittelte Passwort zu
                ändern und ein neues, individuelles Passwort zu verwenden, welches mindestens acht (8) Zeichen und dabei je einen Klein- und einen
                Großbuchstaben sowie ein nummerisches Zeichen enthält.
            </p>
            <p>
                Die Verwendung des Passworts ist zeitlich beschränkt und läuft spätestens nach einem Jahr ab. Nach Ablauf dieses Zeitraums ist die
                Verwendung eines neuen Passworts erforderlich, welches ebenfalls wieder mindestens acht (8) Zeichen und dabei je einen Klein- und
                einen Großbuchstaben sowie ein nummerisches Zeichen enthält. Bei Nichtbeachtung dieser Vorgabe ist die Sportcast berechtigt, den
                Zugang zum Portal zu sperren.
            </p>
            <span className="sub-header-span">
                2.4 Informationspflicht bei Aufgabe der Tätigkeit
            </span>
            <p>Die Zugangsberechtigung zu dem Portal ist tätigkeitsbezogen. Der Nutzer hat die Sportcast darüber zu informieren, wenn er aus seiner
                Tätigkeit, aufgrund derer er eine Zugangsberechtigung zum Portal erhalten hat, ausscheidet. Diese Meldung an die Sportcast hat
                unverzüglich ab Kenntnis des bevorstehenden Ausscheidens, jedoch spätestens zwei Wochen vor Ausscheiden aus der Tätigkeit zu erfolgen.
                Eine entsprechende Informationspflicht besteht, wenn der Nutzer seinen Zugang zum Portal aus anderen Gründen nicht mehr benötigt.</p>
            <span className="header-span">
                3. Berechtigungskonzept; Services und Inhalte des Portals
            </span>
            <p>
                Unter Beachtung dieser Nutzungsbedingungen gewährleistet die Sportcast dem Nutzer nach Maßgabe des von der Sportcast im eigenen
                Ermessen erstellten Berechtigungskonzepts und den gemäß dieses Konzepts im eigenen Ermessen zugewiesenen Zugriffsrechten Zugriff auf
                das Portal und dessen einzelne Bereiche sowie die dort jeweils bereitgestellten Inhalte.
            </p>
            <p>
                Die Sportcast behält sich ausdrücklich das Recht vor, die Bereiche und die Inhalte des Portals ganz oder teilweise ohne vorhergehende
                Ankündigung zu ändern, zu ergänzen, gänzlich zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen. Der Nutzer
                hat keinen Anspruch auf eine dauerhafte Verfügbarkeit sämtlicher Bereiche und Inhalte. Durch Wartungsarbeiten und/oder
                Weiterentwicklung der einzelnen Bereiche und Inhalte kann die Nutzungsmöglichkeit eingeschränkt und/oder zeitweise unterbrochen
                werden. Dadurch ist im Einzelfall nicht auszuschließen, dass es auch zu Verlusten von Eintragungen der Nutzer kommen kann
                (Datenverlust).
            </p>
            <span className="header-span">
                4. Einstellung von Inhalten durch den Nutzer
            </span><br/>
            <span className="sub-header-span">
                4.1 Vom Nutzer eingestellte Inhalte
            </span>
            <p>
                Der Nutzer ist verpflichtet, Inhalte, die nach Maßgabe des Berechtigungskonzepts (Ziffer 3) von ihm in das Portal eingestellt werden,
                sorgfältig zu recherchieren und zu überprüfen und ist für die Richtigkeit und Vollständigkeit der von ihm eingestellten Inhalte
                verantwortlich. Die Sportcast weist darauf hin, dass Inhalte, die durch die Nutzer in dem Portal bereitgestellt werden, grundsätzlich
                nicht überprüft werden, es sei denn, es besteht eine Verpflichtung aus zwingendem geltendem Recht. Der Nutzer stellt die Sportcast von
                etwaigen Ansprüchen Dritter frei, die gegen die Sportcast wegen der Bereitstellung von ihm eingestellter falscher oder inhaltlich
                unrichtiger Inhalte geltend gemacht werden. Des Weiteren ist die Sportcast zur Löschung von Inhalten berechtigt, sofern diese gegen
                die Bestimmungen dieser Nutzungsbedingungen verstoßen.
            </p>
            <span className="sub-header-span">
                4.2 Missbräuchliche Nutzung des Portals
            </span>
            <p>
                Das Portal darf nicht missbräuchlich genutzt werden. Unzulässig sind insbesondere
            </p>
            <ul>
                <li>
                    die vorsätzliche Eingabe von falschen Daten in die Systeme des Portals;
                </li>
                <li>
                    die Vornahme von Eingriffen in das Portal, zu denen der Nutzer nicht autorisiert ist;
                </li>
                <li>
                    der Verstoß gegen regionales, nationales oder internationales Recht (oder gegen einschlägiges Sportrecht; das gilt auch für jede
                    Art von Regelungen mit Gesetzescharakter, die während der Benutzung des Portal oder im Zusammenhang mit der Benutzung des Portals
                    anwendbar sind;
                </li>
                <li>
                    die Einstellung sowie Speicherung, Veröffentlichung oder Verbreitung von urheber-, medien-, patent-, namens-, kennzeichnungs-
                    oder sonst rechtlich geschützten Inhalten ohne Einverständnis des/der Rechteinhaber(s); insbesondere dürfen keine
                    immateriellgüterrechtlich geschützten Inhalte, Darstellungen und Darbietungen eingestellt, gespeichert, veröffentlicht oder
                    verbreitet werden, ohne dass der Nutzer die dafür notwendigen Rechte hat.
                </li>
            </ul>
            <p>
                Bei Verdacht auf eine missbräuchliche/unerlaubte Nutzung des Portals erfolgt eine Überprüfung durch den betrieblichen
                Datenschutzbeauftragten der Sportcast. Er veranlasst ggf. weitere Untersuchungsmaßnahmen. Ein Verstoß gegen die Nutzungsbedingungen
                kann die Kündigung des Nutzungsverhältnisses nach sich ziehen. Die Sportcast behält sich in solchen Fällen vor, den Verband, Club oder
                Arbeitgeber dem der Nutzer angehört, von der Kündigung und den zugrundeliegenden Gründen in Kenntnis zu setzen.
            </p>
            <p>
                Der Nutzer stellt die Sportcast von etwaigen Ansprüchen Dritter frei, die gegen die Sportcast wegen der Verletzung von Rechten Dritter
                durch ihn oder wegen eines sonstigen gesetzes- oder vertragswidrigen von ihm eingestellten Inhaltes geltend gemacht werden.
            </p>
            <span className="header-span">
                5. Rechte an und Nutzung von Inhalten des Portals
            </span><br/>
            <span className="sub-header-span">
                5.1 Urheberrechte und geistiges Eigentum der im Portal bereitgestellten Inhalte
            </span>
            <p>
                Die in dem Portal bereitgestellten Inhalte, insbesondere die bereitgestellten Kennzeichen der Sportcast und der Clubs, unterliegen
                dem deutschen Urheber- und Leistungsschutzrecht, Marken- und Kennzeichenrecht sowie anderen Gesetzen zum Schutz geistigen Eigentums.
            </p>
            <p>Die Sportcast behält sich gemäß § 44b Abs. 3 UrhG ausdrücklich die Vervielfältigung der auf dem Portal verfügbaren Inhalte für Zwecke
                des Text und Data Mining vor. Jegliche automatisierten Programme, Applets, Bots oder ähnliche Technologien dürfen nicht zum Zugriff,
                zur Analyse oder zum Download der über das Portal verbreiteten Inhalte verwendet werden. Dies gilt insbesondere für die Nutzung der
                über das Portal verbreiteten Inhalte für das Training von KI-Systemen.
            </p>
            <p><i>Pursuant to Section 44b para. 3 of the German Act on
                Copyright and Related Rights (Urheberrechtsgesetz, “UrhG”), the Sportcast expressly reserves the right to reproduce the content
                available on the Portal for the purposes of text and data mining. Any automated programmes, applets, bots or similar technologies
                may not be used to access, analyse or download the content distributed via the Portal. This applies in particular to the use of
                the content distributed via the Portal for training AI systems.</i></p>
            <span className="sub-header-span">
                5.2 Von der Sportcast eingestellte Inhalte
            </span>
            <p>
                Die Nutzung der Inhalte des Portals ist dem Nutzer nur im Rahmen und nach Maßgabe dieser Nutzungsbedingungen, insbesondere unter
                Beachtung der Bestimmungen zur Vertraulichkeit und zum Datenschutz, sowie der einschlägigen gesetzlichen Bestimmungen gestattet. Die
                Nutzung der Inhalte des Portals für andere Zwecke, ist nicht gestattet Im Fall eines Verstoßes behält sich die Sportcast jede Form von
                rechtlichen Schritten, insbesondere die Forderung von Schadensersatz, vor.
            </p>
            <span className="sub-header-span">
                5.3 Vom Nutzer eingestellte Inhalte
            </span>
            <p>
                Die vom Nutzer ausdrücklich für die Sportcast eingestellten Inhalten (z.B. zu Vorfällen im Rahmen der Produktion) werden mit Zeitpunkt
                der Einstellung als zentrale Datensammlung sowie -verwaltung und insbesondere zur Ermöglichung eines nachhaltiges Qualitätsmanagement
                langfristig abrufbar gespeichert. Weiterhin werden Eingaben verglichen und Auswirkungen (bspw. von geschehenen Fehlern) über die
                gesamte Wertschöpfungskette nachzuvollzogen. Mit deren Einstellung räumt der Nutzer der Sportcast dementsprechend die hierfür
                erforderlichen Rechte ein. Insbesondere ist die Sportcast berechtigt, diese Inhalte zu verbreiten, zu bearbeiten, in andere
                Darstellungsformen zu übertragen und auf sonstige Art und Weise zu verändern, fortzusetzen und zu ergänzen, in unveränderter und
                veränderter Form zu verbreiten und öffentlich wiederzugeben.
            </p>
            <span className="sub-header-span">
                5.4 Feedback durch den Nutzer
            </span>
            <p>
                Die Sportcast gibt den Nutzern (z.B. über ein separates Microsoft Forms-Feedbackformular oder per E-Mail) die Möglichkeit, ein
                Feedback zu dem Portal und seinen Funktionen zu geben sowie um aufgetretene Fehler zu melden. Das Feedback und die weiteren
                Rückmeldungen verwendet die Sportcast dazu, das Portal und die angebotenen Funktionen zu verbessern. Mit Einsendung räumt der Nutzer
                der Sportcast das zeitlich, örtlich und inhaltlich unbeschränkte, unentgeltliche und exklusive Nutzungsrecht, dieses Feedback und
                weitere Rückmeldung für die vorstehend genannten Zwecke zu nutzen, sie soweit hierfür erforderlich zu bearbeiten oder mit anderen
                Inhalten zu verbinden.
            </p>
            <p>
                Der Nutzer hat sicherzustellen, dass sein Feedback und sein etwaigen weiteren Rückmeldungen keine Rechte Dritter verletzen. Dem
                Produkttester ist bewusst, dass all dies freiwillig und unentgeltlich geschieht und ihm aus diesem Grunde kein
                Vergütungs-/Ausgleichsanspruch gegen die Sportcast zusteht, auch dann nicht, wenn das Feedback oder die weitere Rückmeldung in dem
                Portal oder einer Weiterentwicklung des Portals aufgegriffen werden.
            </p>
            <span className="sub-header-span">
                5.5 Weitergabe durch die Sportcast
            </span>
            <p>
                Die Sportcast berechtigt, die von dem Nutzer eingestellten Inhalte an Dritte weiterzugeben und/oder zu löschen, sofern dies aufgrund
                der Bestimmungen dieser Nutzungsbedingungen, mit den Nutzern getroffenen Vereinbarungen oder gesetzlicher Bestimmungen oder
                richterlicher bzw. behördlicher Anordnungen gestattet oder erforderlich ist. Das gilt auch für die Bekanntgabe von Nutzerdaten nach
                Maßgabe der Bestimmungen dieser Nutzungsbedingungen zum Datenschutz.
            </p>
            <span className="header-span">
                6. Vertraulichkeit
            </span>
            <p>
                Die in dem Portal bereitgestellten Inhalte sind – auch soweit dies im Einzelnen nicht gesondert gekennzeichnet ist – grundsätzlich
                vertraulich zu behandeln, soweit ihrer Veröffentlichung und/oder der sonstigen Weitergabe an Dritte nicht vorab ausdrücklich durch die
                Sportcast zugestimmt worden ist oder die betreffenden Inhalte nach ihrem Inhalt und Zweck von vornherein für die Veröffentlichung und
                Weitergabe an Dritte vorgesehen sind. Alle in dem Portal bereitgestellten Inhalte und von der Sportcast zur Verfügung gestellten
                Unterlagen und Dateien sind daher sorgfältig aufzubewahren. Es ist dafür Sorge zu tragen, dass Dritte keine Einsicht nehmen können,
                und die Inhalte umgehend gelöscht werden, sobald sie für den bestimmungsgemäßen Zweck nicht mehr benötigt werden. Eine Weitergabe
                abgerufener Informationen, Dokumente und Unterlagen an Nutzer, die für den betreffenden Bereich des Portals keine
                Zugriffsberechtigung haben und/oder an Dritte darf nur unter Beachtung der geltenden datenschutzrechtlichen Bestimmungen und nur
                dann erfolgen, wenn die Sportcast der Weitergabe vorab ausdrücklich schriftlich zugestimmt hat.
            </p>
            <span className="header-span">
                7. Protokollierung und Kontrolle
            </span>
            <p>
                Die Sportcast behält sich vor, zur Kontrolle bzgl. der Einhaltung der Bestimmungen dieser Nutzungsbedingungen sowie zur etwaigen
                Fehlerbehebung die Nutzung des Portals zu protokollieren. Für diesen Fall werden die Verbindungsdaten für den Zugang zum Portals mit
                Angaben von Datum/Uhrzeit, Adresse des Nutzers und genutzte Inhalte und Seiten protokolliert. Die Protokolle werden neben der
                Verwendung zu Vertragszwecken nur zu Zwecken der
            </p>
            <ul>
                <li>
                    Analyse und Korrektur technischer Fehler
                </li>
                <li>
                    Gewährleistung der Systemsicherheit
                </li>
                <li>
                    Optimierung des Nutzers
                </li>
                <li>
                    statistische Feststellung des Gesamtnutzungsvolumens und
                </li>
                <li>
                    der Auswertung im Rahmen der Missbrauchskontrolle nach Ziffer 7 verwendet.
                </li>
            </ul>
            <p>
                Die Sportcast behält sich die stichprobenhafte Sichtung der Protokolle vor. Der Zugriff auf die Protokolle ist auf den
                Datenschutzbeauftragten der Sportcast und die mit der Systemadministration betrauten Personen begrenzt.
            </p>
            <p>
                Rechtsgrundlage der Verarbeitung ist Art. 6 Abs. 1 Satz 1 f) der Europäischen Datenschutz-Grundverordnung (<b>„DSGVO“</b>). Die
                berechtigten
                Interesse der Sportcast liegen in der Auswertung dieser Protokolldaten zum Zweck der Optimierung und Sicherheit des Portals.
            </p>
            <span className="header-span">
                8. Haftung des Nutzers
            </span>
            <p>
                Der Nutzer haftet für alle Verstöße gegen diese Nutzungsbedingungen und die darin übernommenen Pflichten, sowie für alle Verstöße
                gegen gesetzliche Vorschriften und für daraus resultierende Forderungen. Der Nutzer haftet insbesondere für die Schäden, die aufgrund
                der verschuldeten unberechtigten Nutzung des Portals durch einen Dritten mit seinem Benutzernamen entstehen. Der Nutzer verpflichtet
                sich, die Sportcast und mit die mit der Sportcast geschäftlich verbundenen Unternehmen von Ansprüchen Dritter freizustellen, die sich
                aus Verletzungen dieser Nutzungsbedingungen durch ihn ergeben.
            </p>
            <span className="header-span">
                9. Haftung der Sportcast
            </span><br/>
            <span className="sub-header-span">
                9.1 Keine Gewähr für Richtigkeit der Inhalte des Portals
            </span>
            <p>
                Alle im Portal bereitgestellten Inhalte werden sorgfältig recherchiert. Die Sportcast übernimmt jedoch keine ausdrückliche oder
                stillschweigende Verantwortung oder Garantie für die Aktualität, inhaltliche Richtigkeit, Vollständigkeit oder sonstige Qualität der
                bereitgestellten Inhalte. Dies gilt insbesondere für die durch die Nutzer des eingestellten Inhalte (Ziffer 4.1).
            </p>
            <span className="sub-header-span">
                9.2 Verlinkung
            </span>
            <p>
                Das Portal enthält Verweise auf fremde Websites in Form eines so
                genannten &quot;Link&quot; oder &quot;Hyperlink&quot; (<b>&quot;verlinkte Websites&quot;</b>). Da die
                Sportcast auf die aktuellen und zukünftigen Inhalte der verlinkten Websites keinerlei Einfluss hat, distanziert sie sich hiermit
                ausdrücklich von sämtlichen Inhalten der entsprechenden Websites. Die Erklärung gilt ausdrücklich für alle derzeitigen und zukünftigen
                innerhalb des Portals selbst oder durch die Nutzer angebrachten Verweise sowie für Verweise, die durch Dritte auf der Website des
                Anbieters angebracht wurden oder zukünftig werden.
            </p>
            <p>
                Die Sportcast kann daher weder direkt noch indirekt für illegale, fehlerhafte oder unvollständige Inhalte verlinkter Websites
                verantwortlich gemacht werden. Insbesondere haftet die Sportcast nicht für Schäden materieller oder ideeller Art, die aus der Nutzung
                oder Nichtnutzung des Inhaltes einer verlinkten Website oder auf Grund von Waren oder Dienstleistungen entstehen, die aus verlinkten
                Websites bezogen wurden.
            </p>
            <span className="sub-header-span">
                9.3 Sonstige Haftung der Sportcast
            </span>
            <p>
                Für die von der Sportcast im Rahmen des Portals unentgeltlich bereitgestellten Leistungen und Inhalte, die nicht Gegenstand eines
                gesondert abgeschlossenen entgeltlichen Vertrags sind, gelten folgende Haftungsbestimmungen:
            </p>
            <p>
                Die Haftung der Sportcast für Schäden, gleich aus welchem Rechtsgrund und welcher Art, wird ausgeschlossen, es sei denn sie beruhen
                auf Vorsatz oder grober Fahrlässigkeit. Dies gilt insbesondere bezüglich Schäden materieller oder ideeller Art, die durch die Nutzung
                oder Nichtnutzung der in dem Portal angebotenen Informationen beziehungsweise durch die Nutzung veralteter, fehlerhafter,
                unvollständiger oder sonst in der Qualität mangelhafter Informationen verursacht wurden sowie für mittelbare Schäden.
            </p>
            <p>
                Die Sportcast übernimmt keine Haftung für alle durch Nutzer oder sonstige Dritte bereitgestellte Inhalte. Gleiches gilt für den
                Verlust oder Missbrauch von Daten, sofern dies durch Unterlassungen oder falsche Anwendungen des Datenschutzes durch den Nutzer
                bedingt ist.
            </p>
            <p>
                Die Haftungsbeschränkungen gelten nicht für eine von der Sportcast zu vertretende vorsätzliche oder fahrlässige Verletzung von Leib,
                Leben, Gesundheit, die Haftung nach dem Produkthaftungsgesetz.
            </p>
            <p>
                Die Sportcast übernimmt keine Gewähr dafür, dass das Portal oder die Server, die es zur Verfügung stellen, keine Viren oder andere
                schädliche Elemente enthalten. Die Nutzung des Portals erfolgt auf eigenes Risiko, der Nutzer ist insbesondere alleine
                verantwortlich für etwaige Datenverluste oder Schäden an seinem Computersystem. Der Nutzer hat für einen einwandfreien, geeigneten
                und aktuellen Virenschutz auf seinem Rechner zu sorgen.
            </p>
            <p>
                Soweit die Haftung der Sportcast ausgeschlossen oder beschränkt ist, gilt dies auch zugunsten der Sportcast nach § 15 ff. AktG
                verbundenen Unternehmen sowie gegen Organ- und sonstige Gremienmitglieder, der Mitarbeiter, Vertreter und/oder Erfüllungsgehilfen der
                Sportcast sowie die mit der Sportcast nach §§ 15 ff. AktG verbundenen Unternehmen.
            </p>
            <span className="header-span">
                10. Beendigung des Nutzungsverhältnisses
            </span><br/>
            <span className="sub-header-span">
                10.1 Ordentliche Kündigung durch den Nutzer
            </span>
            <p>
                Der Nutzer ist vorbehaltlich etwaiger entgegenstehender Pflichten gegenüber seinem Verband, Club oder Arbeitgeber jederzeit
                berechtigt, das Nutzungsverhältnis ohne Angabe von Gründen schriftlich zu kündigen. Eine Kündigung per E-Mail ist an die
                E-Mailadresse <a
                href="mailto:registration.report@sportcast.de">registration.report@sportcast.de</a> zu richten.
            </p>
            <span className="sub-header-span">
                10.2 Ordentliches Kündigungsrecht der Sportcast
            </span>
            <p>
                Das Nutzungsverhältnis ist für die Sportcast mit einer Frist von zwei Wochen per E-Mail an die registrierte E-Mail-Adresse des Nutzers
                kündbar. Das Nutzungsverhältnis endet ferner, wenn der Verband, Club oder Arbeitgeber, dem der Nutzer angehört, dem Nutzer die
                Zugangsberechtigung entzieht und dies der Sportcast entsprechend anzeigt (Ziffer 2.3).
            </p>
            <span className="sub-header-span">
                10.3 Außerordentliche Kündigung des Nutzungsverhältnisses aus wichtigem Grund
            </span>
            <p>
                Das Rechts zur (fristlosen) Kündigung aus wichtigem Grund bleibt unberührt. Das gilt insbesondere für den Fall, dass der Nutzer die
                Nutzungsregeln für das Portal und/oder sonstige ihm obliegende Pflichten erheblich und/oder nachhaltig verletzt.
            </p>
            <span className="sub-header-span">
                10.4 Informationsrecht der Sportcast
            </span>
            <p>
                Die Sportcast behält sich vor, im Falle der Kündigung des Nutzungsverhältnisses, den Verband, Club oder Arbeitgeber, dem der Nutzer
                angehört, von der Kündigung und deren Gründe in Kenntnis zu setzen. Wenn der Zugang eines Nutzers zum Portal von der Sportcast
                gesperrt oder gelöscht wurde, darf der Nutzer auf das Portal nicht mehr zugreifen, sofern er von der Sportcast nach der Sperrung
                nicht eine ausdrückliche Zustimmung in Textform dazu erhalten hat.
            </p>
            <span className="header-span">
                11. Änderung der Nutzungsbedingungen; Kündigung des Nutzungsverhältnisses
            </span><br/>
            <span className="sub-header-span">
                11.1 Änderung der Nutzungsbedingungen
            </span>
            <p>
                Die Sportcast behält sich das Recht vor, diese Nutzungsbedingungen zu ändern, sofern die Änderung der Nutzungsbedingungen unter
                Berücksichtigung der Interessen der Sportcast für den Nutzer zumutbar ist. Änderungen der Nutzungsbedingungen wird die Sportcast
                spätestens zwei Wochen vor deren Inkrafttreten in über die Internetdomain des Portals unter report.sportcast.de bekanntgeben.
            </p>
            <span className="sub-header-span">
                11.2 Kündigung des Nutzungsverhältnisses im Fall der Änderung
            </span>
            <p>
                Sofern der Nutzer mit einer Änderung der Nutzungsbedingungen nicht einverstanden ist, hat er das Recht, das Nutzungsverhältnis
                jederzeit mit sofortiger Wirkung zu kündigen. Die Änderung der Nutzungsbedingungen gilt als genehmigt, wenn der Nutzer den Dienst
                auch einen Monat nach Inkrafttreten der Änderung noch weiter nutzt. Die Sportcast wird hierauf im Rahmen der Bekanntgabe der Änderung
                besonders hinweisen.
            </p>
            <span className="header-span">
                12.Schlussbestimmungen
            </span><br/>
            <span className="sub-header-span">
                12.1 Gerichtsstand; Anwendbares Recht
            </span>
            <p>
                Der Gerichtsstand für Streitigkeiten, die aus oder im Zusammenhang mit der Nutzung des Portals entstehen, ist, soweit die Vereinbarung
                eines Gerichtsstandes rechtlich zulässig ist, Köln, Deutschland. Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss
                aller Rechtsnormen, die in eine andere Rechtsordnung verweisen. Die Anwendung des Internationalen Privatrechts sowie des
                UN-Kaufrechts sind ausdrücklich ausgeschlossen.
            </p>
            <span className="sub-header-span">
                12.2 Salvatorische Klausel
            </span>
            <p>
                Sofern Teile oder einzelne Formulierungen dieser Nutzungsbedingungen der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig
                entsprechen sollten, bleiben die übrigen Teile der Nutzungsbedingungen in ihrem Inhalt und ihrer Gültigkeit davon unberührt. Anstelle
                des ungültigen Teils oder der ungültigen Formulierung soll eine Formulierung treten, die der ursprünglichen Formulierung möglichst
                nahe kommt.
            </p>

            <div className="text-end mt-4">Stand: 01.07.2023</div>
        </div>
    );
};
export default TermsOfUseText;